import React, { useEffect } from 'react'
import { Deal } from '../models/shared/Deal'
import { Badge, Spinner } from 'react-bootstrap';
import { zeroPad } from '../utils/presentation';
import { useOrganization } from '../context/OrganizationContext';
import { useText } from '../context/TextContext';
import { Link } from 'react-router-dom';
import { PATHS, QUERY_PARAMS } from '../utils/shared/constants';

interface Props {
    deal: Deal;
    onForceUpdate: () => void;
}

const FORCE_UPDATE_TIMEOUT = 1000 * 2;

export default function Distance(props: Props) {
    const { deal, onForceUpdate } = props;
    const text = useText();
    const { organization } = useOrganization();

    useEffect(() => {
        if (!deal.place?.placeId || !organization.place?.placeId) {
            return;
        }
        if (deal.placeDistance) {
            return;
        }

        const timeout = setTimeout(() => {
            console.log('Force update distance');
            onForceUpdate();
        }, FORCE_UPDATE_TIMEOUT);
        return () => {
            clearTimeout(timeout);
        }

    }, [deal.place?.placeId, deal?.placeDistance, organization.place?.placeId, onForceUpdate])

    if (!deal.place?.placeId) {
        return <></>
    }

    if (!organization.place?.placeId) {
        return <Link to={`${PATHS.ORGANIZATIONSETTINGS}?${QUERY_PARAMS.BACK}=true`}>
            <p className='m-0 small'>
                <i className='bi bi-sign-turn-right me-2' />{text.setCompanyAddressToEnableDistanceCalculation}
            </p>
        </Link>
    }

    const distance = deal.placeDistance;
    if (!distance) {
        return <div className='d-flex gap-1'>
            <Badge bg="secondary"><i className='bi bi-sign-turn-right me-2' /><Spinner size='sm' /></Badge>
        </div>
    }

    const distanceKm = Math.round((distance.distanceMeters || 0) / 1000);
    const minutes = Math.round((distance.durationSeconds || 0) / 60);
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    return (<div className='d-flex gap-1'>
        <Badge bg="secondary"><i className='bi bi-sign-turn-right me-2' />{distanceKm} km</Badge>
        <Badge bg="secondary"><i className='bi bi-clock me-2' />{hours}:{zeroPad(remainingMinutes)}</Badge>
    </div>
    )
}
